import { uniqueId } from 'lodash';

import { generateOrganizationId } from 'dashboard/lib/stubs/organization';
import { Team, TeamAttributes, TeamRelationships } from 'dashboard/models/team';
import { ApiModel } from 'lib/interfaces/api';

export const generateTeamId = () => uniqueId('team_');
const timestamp = new Date().toISOString();

export function createMockTeam(
  attributes?: Partial<TeamAttributes>,
  relationships?: Partial<TeamRelationships>,
  id?: string,
): Team {
  return {
    id: id || generateTeamId(),
    type: ApiModel.Team,
    attributes: {
      name: 'Starburst',
      status: 'active',
      'organization-id': generateOrganizationId(),
      'created-at': timestamp,
      'updated-at': timestamp,
      'archived-at': '',
      'active-user-count': 0,
      ...attributes,
    },
    relationships: {
      users: {
        data: [],
      },
      ...relationships,
    },
  };
}
